import { inject, Injectable } from '@angular/core';
import { IStopAddress } from '@okcargo-apps/shared-domain';
import { IAddressBookEntry } from '@okcargo-apps/shared-domain-ionic';
import {
  AddressbookQueryService,
  mapFromAddressBookResponse,
  mapFromPlaceAddressResponse,
} from '@okcargo-apps/shared-infrastructure-ionic';
@Injectable({
  providedIn: 'root',
})
export class AddressbookService {
  private readonly addressbookQueryService = inject(AddressbookQueryService);

  public async searchAddresses(term: string, abortSignal?: AbortSignal): Promise<IAddressBookEntry[]> {
    if (!term || term.trim().length < 2) {
      return [];
    }

    try {
      const paramsForAddressees = {
        page: 0,
        size: 5,
        sort: ['streetAddress', 'asc'],
        'streetAddress.contains': term.trim(),
        ...(abortSignal && { abortSignal }),
      };

      const response = await this.addressbookQueryService.searchPlaceAddress(
        paramsForAddressees,
        term.trim(),
        abortSignal,
      );

      if (response) {
        return response.map(mapFromAddressBookResponse);
      }
      return [];
    } catch (error: any) {
      if (error?.name === 'AbortError') {
        return [];
      }

      console.error('Error searching in address book:', error);
      return [];
    }
  }

  public async findAddressByPlaceId(placeId: string | number): Promise<IStopAddress | null> {
    try {
      const result = await this.addressbookQueryService.findByPlaceId(placeId);
      return mapFromPlaceAddressResponse(result);
    } catch (error) {
      console.error('Error finding address by placeId:', error);
      return null;
    }
  }
}
